<div class="row" *ngIf="!showshimmerloader && !aidata">
  <div class="col d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <p class="mb-0 mr-3 font-weight-600 f-16 ai-text-gradient">Unlock Our AI-Powered Analysis!</p>
     <div class="text-right">
        <button data-testid="auto-app-talent-insights-ai-button-1" class="wc-btn gradientbtn" (click)="generateai()" [ngClass]="{'disabl-button': (dataPending || totalcount==0 || !requestaidata)}" [disabled]="(dataPending || totalcount==0 || !requestaidata)"><i class="fa-regular  fa-wand-magic-sparkles mr-1"></i> Generate</button>
      </div>
    </div>
      <!-- Export split-button dropdown -->
      <div class="dropdown">
        <button data-testid="auto-app-talent-insights-ai-button-2" class="d-flex border-0 btn-trms-light align-items-center justify-content-center" style="min-width: auto !important; width: auto !important;" [disabled]="(totalcount==0 || !requestaidata)" [ngClass]="{'disabl-button': (totalcount==0 || !requestaidata || jobDemandCount)}" type="button" id="exportDropdownTop" appDropdownToggle aria-haspopup="true" aria-expanded="false">
          <i class="fa-solid fa-download mr-2" [ngClass]="{'text-9696': (totalcount==0 || !requestaidata || jobDemandCount)}"></i>
          Export <i class="fa-solid fa-chevron-down ml-1 f-11"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right" style="z-index: 0;" aria-labelledby="exportDropdownTop">
          <a data-testid="auto-app-talent-insights-ai-a-1" class="dropdown-item f-12 pointer" style="color: #2e93a1 !important" (click)="!(totalcount==0 || !requestaidata || jobDemandCount) && requestInsightsExport()">
            <i class="fa-solid fa-file-pdf mr-2"></i>Export as PDF
          </a>
          <a data-testid="auto-app-talent-insights-ai-a-2" class="dropdown-item f-12 pointer" style="color: #2e93a1 !important" (click)="!(totalcount==0 || !requestaidata || jobDemandCount) && requestInsightsExportExcel()">
            <i class="fa-solid fa-file-excel mr-2"></i>Export as Excel
          </a>
        </div>
    </div>
  </div>
</div>
<div style="height: 130px;" *ngIf="showshimmerloader">
  <p class="f-16 font-weight-600 ai-text-gradient">Keep tight while we generate insightful summaries... </p>
  <div  class="shimmer-loader mb-1" style="height: 18px; border-radius: 14px; background-image: linear-gradient(102deg, #fff7fa 50%, #ffd8e5 80%);"></div>
  <div  class="shimmer-loader mb-1" style="height: 18px; border-radius: 14px; background-image: linear-gradient(102deg, #fff7fa 50%, #ffd8e5 80%);"></div>
  <div  class="shimmer-loader mb-1" style="height: 18px; border-radius: 14px; background-image: linear-gradient(102deg, #fff7fa 50%, #ffd8e5 80%);"></div>
  <div  class="shimmer-loader mb-1" style="height: 18px; border-radius: 14px; background-image: linear-gradient(102deg, #fff7fa 50%, #ffd8e5 80%);"></div>
</div>
<div class="row pl-3 pr-3" *ngIf="aidata">
  <div class="d-flex justify-content-between align-items-center w-100">
    <span class="f-16 font-weight-600 ai-text-gradient">Smart Insights for Talent Decisions</span>
    <!-- Export split-button dropdown -->
    <div class="dropdown">
      <button data-testid="auto-app-talent-insights-ai-button-3" class="d-flex border-0 btn-trms-light align-items-center justify-content-center" style="min-width: auto !important; width: auto !important;" [disabled]="(totalcount==0)" [ngClass]="{'disabl-button': (totalcount==0)}" type="button" id="exportDropdownBottom" appDropdownToggle aria-haspopup="true" aria-expanded="false">
        <i class="fa-solid fa-download mr-2" [ngClass]="{'text-9696': (totalcount==0)}"></i>
        Export <i class="fa-solid fa-chevron-down ml-1 f-11"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="exportDropdownBottom">
        <a data-testid="auto-app-talent-insights-ai-a-3" class="dropdown-item f-12 pointer" style="color: #2e93a1 !important" (click)="!(totalcount==0) && requestInsightsExport()">
          <i class="fa-solid fa-file-pdf mr-2"></i>Export as PDF
        </a>
        <a data-testid="auto-app-talent-insights-ai-a-4" class="dropdown-item f-12 pointer" style="color: #2e93a1 !important" (click)="!(totalcount==0) && requestInsightsExportExcel()">
          <i class="fa-solid fa-file-excel mr-2"></i>Export as Excel
        </a>
      </div>
    </div>
  </div>
  <hr class="w-100 mt-2">
  <div class="d-flex justify-content-between w-100">
    <div #tta class="textBox2 d-flex flex-wrap" style="row-gap: 10px; column-gap: 10px;" [class.viewMore2]="viewMore2">
      <div [innerHtml]="aidata"></div>
      <div>
        <p class="f-14" *ngIf="viewMore2"><span class="font-weight-500">Note: </span> This summary has been AI-generated and may not represent complete information</p>

      </div>
  </div>

</div>
<div class="text-center m-auto pt-3">
  <button data-testid="auto-app-talent-insights-ai-button-4"  class="f-14 font-weight-500 text-webbtree-green text-right pointer reg-btn" (click)="viewMore2 = !viewMore2">{{ viewMore2 ? 'View less': 'View More' }} <i class="far f-14 font-weight-500" [ngClass]="viewMore2 ? 'fa-angle-up': 'fa-angle-down'"></i>
  </button>
</div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>
<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
